import type { RouteDefinition } from "./route-definition.ts";

export const marketingAliasRoutes = {
  job: {
    path: "/jobs/:slug",
    scope: "static",
    bucket: "marketing",
    entry: "compatibility",
    disposition: "resolver",
  },
  about: {
    path: "/about",
    scope: "static",
    bucket: "marketing",
    entry: "compatibility",
    disposition: "resolver",
  },
  cogames: {
    path: "/cogames",
    scope: "static",
    bucket: "marketing",
    entry: "compatibility",
    disposition: "resolver",
  },
  alignmentleague: {
    path: "/alignmentleague",
    scope: "static",
    bucket: "marketing",
    entry: "compatibility",
    disposition: "resolver",
  },
  alignmentleagueAlias: {
    path: "/alb/*path?",
    scope: "static",
    bucket: "marketing",
    entry: "compatibility",
    disposition: "resolver",
  },
  inspiration: {
    path: "/inspiration",
    scope: "static",
    bucket: "marketing",
    entry: "compatibility",
    disposition: "resolver",
  },
  privacyDocument: {
    path: "/privacy-policy.pdf",
    scope: "static",
    bucket: "marketing",
    entry: "compatibility",
    disposition: "resolver",
  },
} as const satisfies Record<string, RouteDefinition>;
